
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component({})
export default class ModalConfirmTypeForm extends Vue {
  /* PROP */

  @Prop({ default: false })
  private isShow: boolean;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* EMIT */
  @Emit('on-agree')
  private onclickAgree() {
    //
  }

  private clickAgree() {
    this.onclickAgree()
  }
  
}
